import * as parent from '../variables';
import { IS_ADMIN } from '../../constants/validation';

export const colors = {
  ...parent.colors,
  LINK_COLOR: '#2c67ac',
  SECONDARY_MAIN: '#2c67ac',
  PRIMARY_BUTTON_TEXT: '#fff',
  INPUT_COLOR: IS_ADMIN ? '#fff' : '#000',
  HEADER_COLOR: IS_ADMIN ? '#2c2e33' : '#fff',

  ...(IS_ADMIN
    ? {
      LOGIN_BACKGROUND: '#2c2e33',
      CHIP_BG: '#fff',
    }
    : {}),

  ...(IS_ADMIN
    ? {}
    : {
      PRIMARY_MAIN: '#f0f2f2',
      SELECTED_MENU_BG: '#5e5f67',
      PRIMARY_CONTRAST: '#000',
      HEADER_BG: '#030000',
      HEADER_COUNT_TEXT: '#fff',
      HIDE_MENU_TOP_BORDER: true,
      NEW_THEME: true,
      PRIMARY_BORDER: '#f0f2f2',
      GREY: '#999',
      DAILY_LOG_GRAPH_BORDER: '#919191',
      NORMAL_LINK: '#455560',
      MODAL_TEXT: '#797979',
      MODAL_HEADING: '#575757',
      MODAL_BACKGROUND: '#f0f2f2',
      LIST_TEXT: '#5e5f67',
      HEADER_LIST_TEXT: '#8a8a8a',
      LIGHT_BORDER: '#2d2b2b',
      SECONDARY_MAIN: '#2c67ac',
      SECONDARY_CONTRAST: '#5e5f67',
      WHITE: '#fff',
      INPUT_BACKGROUND: '#ffffff',
      RED: '#ff0000',
      BLACK: '#000',
      BACKGROUND: '#fff',
      BLACK_THREE: '#373737',
      RED_TWO: '#d34343',
      GREEN: '#32cd32',
      GREEN_TWO: '#97AE46',
      GREY_ELEVEN: '#777070',
      GREY_TWELVE: '#c3c3c3',
      BLACK_FOUR: '#333333',
      GRAPH_BLACK: '#212121',
      CHART_BLUE: '#00e2ff',
      WARNING: '#ffff00',
      GREY_DATA: '#696969',
      SELECTED_TAB_COLOR: '#2c67ac',
      LINK_COLOR: '#2c67ac',

      DOCUMENT_LINE: '#2C3249',
      DISABLED_COLOR: '#889ccc',
      RADIO_BACKGROUND: '#f0f2f2',
      FORM_COLOR: '#191e22',
      SUGGESTED_COLOR: '#00b7a0',
      BODY_BACKGROUND: '#f0f2f2',
      CHECKBOX_TICK: '#2c67ac',
      PAGINATION_BACKGROUND: '#fff',
      PAGINATION_ALTERNATE_BACKGROUND: '#f8f8f8',
      PAGINATION_COLOR: '#fff',
      SELECTED_AREA: 'rgba(32, 177, 232, 0.6)',
      MAP: {
        LIGHT_BLACK: '#353740',
        LIGHTER_BLACK: '#353740',
        BLACK: '#353740',
        GREY: '#d1d1d1',
        LIGHT_GREY: '#d1d1d1',
        LIGHTER_GREY: '#d1d1d1',
        WATER: '#5e5f67',
        ROAD: '#37425C',
      },
      LOGIN_BUTTON: '#2c67ac',
      TAB_LABEL: '#5e5f67',
      BACKGROUND_MENU: '#5e5f67',
      TITLE_COLOR: '#191e22',

      INPUT_BORDER: '#ccc',
      INPUT_FOCUS: '#2c67ac',
      TABLE_ROW_COLOR: '#39434c',
      SORT_ICON: '#2c67ac',
      LOGOUT_BUTTON: '#2b2a2a',
      PAGINATION_HEADER: '#5e5f67',
      HEADER_TEXT: '#39434c',
      PAGINATION_BORDER: '#f0f2f2',
      RESET_BUTTON: '#455560',
      ACTION_BORDER: '#5e5f67',

      FORM_INPUT_BG: '#f0f2f2',
      MULTISELECT_BACKGROUND: '#5e5f67',
      MULTISELECT_LABEL: '#f0f2f2',
      FORM_BACKGROUND: '#fff',
      RESET_BACKGROUND: '#5e5f67',
      RESET_COLOR: '#ffffff',
      CHECKBOX_BORDER: '#d1d3d6',
      SELECT_ACTIONS: '#444',
      SECONDARY_BORDER: '#d0d4d7',
      TAB_HIGHLIGHT: '#000',
      TAB_BOTTOM_BORDER: '#2c67ac',
      TAB_HIGHLIGHT_BACKGROUND: '#fff',
      ACCORDION_BACKGROUND: '#fff',
      USER_LOGO_BACKGROUND: '#5e5f67',
      USER_LOGO_COLOR: '#ffffff',
      POLICIES_BACKGROUND: '#fff',
      MENU_TITLE: '#fff',
      SELECTED_MENU_TITLE: '#fff',
      MENU_BORDER_COLOR: '#2c67ac',
      MENU_BACKGROUND: '#353740',
      RANGE_PICKER: {
        CELL_BG: '#dfdfdf',
        CELL_HOVER_BG: '#bbbbbb',
      },
    }),
};
export default colors;
export const fonts = ['NotoSans-Regular', 'sans-serif'].join(',');
